import { render, staticRenderFns } from "./SwotItem.vue?vue&type=template&id=515f6a95&scoped=true"
import script from "./SwotItem.vue?vue&type=script&lang=js"
export * from "./SwotItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515f6a95",
  null
  
)

export default component.exports